document.addEventListener('DOMContentLoaded', function () {
	const page = document.querySelector('[data-article-page]');
	const toc = page && page.querySelector('[data-article-toc]');
	if (!toc) {
		return;
	}

	const header = document.querySelector('.vg-header-wrapper');
	const desktop = window.matchMedia('(min-width: 992px)');
	const entries = Array.from(toc.querySelectorAll('a[href^="#"]')).map(function (link) {
		return {link, heading: document.getElementById(decodeURIComponent(link.hash.slice(1)))};
	}).filter(function (entry) {
		return entry.heading;
	});
	let frame = null;
	let tocTop = null;
	let navigation = null;
	let animation = null;

	function update() {
		frame = null;
		const now = performance.now();
		const offset = (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + 24;
		page.style.setProperty('--article-header-offset', offset + 'px');
		let active = entries[0];
		entries.forEach(function (entry) {
			if (entry.heading.getBoundingClientRect().top <= Math.max(offset + 24, window.innerHeight * .25)) {
				active = entry;
			}
		});
		if (navigation) {
			if (navigation.scroll !== window.scrollY) {
				navigation.scroll = window.scrollY;
				navigation.changedAt = now;
			}
			// Не переключаем оглавление на промежуточные разделы во время плавного перехода.
			if (now - navigation.changedAt < 150) {
				active = navigation.entry;
			} else {
				navigation = null;
			}
		}
		if (desktop.matches) {
			const bottom = Math.min(offset, window.innerHeight - toc.offsetHeight - 24);
			let top = offset;
			if (active && active !== entries[0] && bottom < offset) {
				const origin = toc.getBoundingClientRect().top;
				const link = active.link.getBoundingClientRect();
				const center = (offset + window.innerHeight - 24) / 2;
				// Оставляем соседние пункты с обеих сторон, ограничивая смещение краями списка.
				top = active === entries[entries.length - 1] ? bottom : center - ((link.top + link.bottom) / 2 - origin);
			}
			top = Math.max(bottom, Math.min(offset, top));
			if (animation) {
				const progress = Math.min(1, (now - animation.startedAt) / 280);
				top = animation.from + (top - animation.from) * (1 - Math.pow(1 - progress, 3));
				if (progress === 1) {
					animation = null;
				}
			}
			tocTop = Math.max(bottom, Math.min(offset, top));
			toc.style.setProperty('--article-toc-top', tocTop + 'px');
			// Скрытая часть высокого списка не должна заполнять зазор под плавающей шапкой.
			toc.style.setProperty('--article-toc-clip', Math.max(0, offset - toc.getBoundingClientRect().top) + 'px');
		} else {
			toc.style.removeProperty('--article-toc-top');
			toc.style.removeProperty('--article-toc-clip');
			tocTop = null;
			animation = null;
		}
		entries.forEach(function (entry) {
			entry.heading.style.scrollMarginTop = offset + 'px';
			if (entry === active) {
				entry.link.setAttribute('aria-current', 'location');
			} else {
				entry.link.removeAttribute('aria-current');
			}
		});
		if (navigation || animation || (header && header.getAnimations && header.getAnimations().some(function (item) {
			return item.playState === 'running';
		}))) {
			schedule();
		}
	}

	function schedule() {
		if (frame === null) {
			frame = requestAnimationFrame(update);
		}
	}

	window.addEventListener('scroll', schedule, {passive: true});
	window.addEventListener('resize', schedule, {passive: true});
	['wheel', 'touchstart', 'keydown'].forEach(function (name) {
		window.addEventListener(name, function () {
			navigation = null;
			animation = null;
			schedule();
		}, {passive: true});
	});
	toc.addEventListener('click', function (event) {
		const link = event.target.closest('a[href^="#"]');
		const entry = entries.find(function (item) {
			return item.link === link;
		});
		if (!entry) {
			return;
		}

		if (frame !== null) {
			cancelAnimationFrame(frame);
		}
		update();
		event.preventDefault();
		const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		navigation = {entry, scroll: window.scrollY, changedAt: performance.now()};
		animation = !reducedMotion && desktop.matches ? {from: tocTop, startedAt: performance.now()} : null;
		entry.heading.scrollIntoView({behavior: reducedMotion ? 'instant' : 'smooth', block: 'start'});
		history.replaceState(null, '', link.hash);
		entry.heading.setAttribute('tabindex', '-1');
		entry.heading.focus({preventScroll: true});
		schedule();
	});
	const observer = new ResizeObserver(schedule);
	observer.observe(toc);
	if (header) {
		observer.observe(header);
		new MutationObserver(schedule).observe(header, {attributes: true, attributeFilter: ['class', 'style']});
		header.addEventListener('transitionend', schedule);
	}
	update();
});
